import React  from 'react';  

export const practitionerviewConfig = [
 
  {
    auth: ['user'],
    routes: [
      {
        exact: false,
        path: '/practitioner-statements/view',
        component: React.lazy(() => import('./ViewPract')),
      },
    ],
  },
 
];